<div [innerHTML]="sanitizedDOMString"></div>
